module.exports = __webpack_public_path__ + "static/img/code1.d702a13.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/code1.png
// module id = J9/i
// module chunks = 41